/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateFileTagDestroyPathParams,
	CandidateFileTagDestroyResponse,
} from '../types/CandidateFileTagDestroy'

/**
 * DELETE /candidates/:candidateId/files/:fileId/tag
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileTagController.php CandidateFileTagController::destroy
 */
export async function candidateFileTagDestroy(
	candidateId: CandidateFileTagDestroyPathParams['candidateId'],
	fileId: CandidateFileTagDestroyPathParams['fileId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFileTagDestroyResponse>> {
	return axiosInstance.delete(`/candidates/${candidateId}/files/${fileId}/tag`, config)
}
